


































/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import { State, Action } from "vuex-class";

import { NavigationService } from "../../NavigationServices/navigation";
import { ListItemDTO, PubIssueDTO } from "../../Generated/ParticaAPI";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import StateMixin from "../../Mixins/StateMixin";
import { IIssueConversionService } from "../../BusinessServices/issueconversion";
import IssueList from "@/Ui-Components/Title/IssueList/IssueListv2.vue";


const namespace: string = "config";

@Component(
	{
		name: "RecentIssues",
		components: {
			ParticaError,
			ParticaCard,
			ParticaView,
			IssueList
		},
		mixins: [StateMixin]
	})
export default class RecentIssues extends ParticaAdminBase {
	private issueConversionService: IIssueConversionService;
	private query: string = "";
	private data = [] as PubIssueDTO[];
	private listactions: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.ADMIN_SELECT_ACCOUNT, label: "Select" } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.ISSUE_SELECT: {
					this.navigate("issue", { id: event.item.isssueId as string });
					break;
				}
				case eParticaAction.RIGHT_MOUSE_CLICK: {
					this.navigate("issueconversion", { id: event.item.isssueId as string });
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Recent Issues";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getAdminNav(0);
			this.navigationService = new NavigationService();
			this.issueConversionService = this.particaServices.getIssueConversionService();
			this.data = await this.issueConversionService.getRecentConversions();
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
